import { AreaOption } from "../../../select";

export const unitOptions = ["Bộ", "Cái", "Chiếc", "Cục", "Hộp", "Cuộn", "met", "met2", "Tấm", "Cây"];
export const planOptions = ["Mua ngoài", "Xuất kho"];
export const typeVehicleOptions = [
  "Xe 7 chỗ - Có lái xe",
  "Xe 7 chỗ - Không lái xe",
  "Xe 16 chỗ - Có lái xe",
  "Xe 16 chỗ - Không lái xe",
];
export const sexOptions = ["Nam", "Nữ"];

export const areas: AreaOption[] = [
  {
    cases: ["1A", "1-A", "1_A", "1 A"],
    return: { value: "1-A", label: "1-A", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["1B", "1-B", "1_B", "1 B"],
    return: { value: "1-B", label: "1-B", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["1C", "1-C", "1_C", "1 C"],
    return: { value: "1-C", label: "1-C", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["1D", "1-D", "1_D", "1 D"],
    return: { value: "1-D", label: "1-D", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["1"],
    return: { value: "1", label: "1", color: "#000", isDisabled: false },
  },
  {
    cases: ["1ĐỎ", "1-ĐỎ", "1_ĐỎ", "1 ĐỎ", "1Đ", "1-Đ", "1_Đ", "1 Đ"],
    return: { value: "1-Đỏ", label: "1", color: "#FF0000", isDisabled: false },
  },

  {
    cases: ["2"],
    return: { value: "2", label: "2", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["2A", "2-A", "2_A", "2 A"],
    return: { value: "2-A", label: "2-A", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["2C", "2-C", "2_C", "2 C"],
    return: { value: "2-C", label: "2-C", color: "#0b95e6", isDisabled: false },
  },

  {
    cases: ["3"],
    return: { value: "3", label: "3", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["3A", "3-A", "3_A", "3 A"],
    return: { value: "3-A", label: "3-A", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["3B", "3-B", "3_B", "3 B"],
    return: { value: "3-B", label: "3-B", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["3C", "3-C", "3_C", "3 C"],
    return: { value: "3-C", label: "3-C", color: "#0b95e6", isDisabled: false },
  },

  {
    cases: ["4"],
    return: { value: "4", label: "4", color: "#000", isDisabled: false },
  },
  {
    cases: ["4ĐỎ", "4-ĐỎ", "4_ĐỎ", "4 ĐỎ", "4Đ", "4-Đ", "4_Đ", "4 Đ"],
    return: { value: "4-Đỏ", label: "4", color: "#FF0000", isDisabled: false },
  },

  {
    cases: ["5"],
    return: { value: "5", label: "5", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["5A", "5-A", "5_A", "5 A"],
    return: { value: "5-A", label: "5-A", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["5B", "5-B", "5_B", "5 B"],
    return: { value: "5-B", label: "5-B", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["5C", "5-C", "5_C", "5 C"],
    return: { value: "5-C", label: "5-C", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["5D", "5-D", "5_D", "5 D"],
    return: { value: "5-D", label: "5-D", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["5E", "5-E", "5_E", "5 E"],
    return: { value: "5-E", label: "5-E", color: "#0b95e6", isDisabled: false },
  },

  {
    cases: ["6"],
    return: { value: "6", label: "6", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["6A", "6-A", "6_A", "6 A"],
    return: { value: "6-A", label: "6-A", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["6B", "6-B", "6_B", "6 B"],
    return: { value: "6-B", label: "6-B", color: "#0b95e6", isDisabled: false },
  },
  {
    cases: ["6C", "6-C", "6_C", "6 C"],
    return: { value: "6-C", label: "6-C", color: "#0b95e6", isDisabled: false },
  },
];

export const eBizTitleOptions = [
  "Nhân viên",
  "Ca trưởng",
  "Nhóm trưởng",
  "Cán sự",
  "Chuyên viên",
  "Chuyên viên - KCQ",
  "Kíp phó",
  "Kíp trưởng",
  "Đội phó",
  "Đội phó - KCQ",
  "Đội trưởng",
  "Đội trưởng - KCQ",
  "Giáo viên",
  "Phó trung tâm",
  "Phó phòng",
  "Trưởng Phòng",
  "Supervisor",
  "Phó giám đốc",
  "Giám đốc",
];

export const eDepartmentOptions = [
  "Công nghệ thông tin",
  "Tổ chức và Nhân lực",
  "Kinh Doanh",
  "Văn phòng Công ty",
  "Kế hoạch Đầu tư",
  "Tài chính Kế toán",
  "Trung tâm đào tạo",
  "Trung tâm SC&BD TTB",
  "Trung tâm kiểm soát tải",
  "An toàn Chất lượng và An ninh",
  "Ban Giám đốc",
  "Trung tâm điều hành TSN",
  "Trung tâm phục vụ sân đỗ TSN",
  "Trung tâm phục vụ hành khách TSN",
  "Nhóm hành chính tổng hợp TSN",
  "Phòng kế hoạch hành chính NBA",
  "Phòng kế toán NBA",
  "Trung tâm phục vụ sân đỗ NBA",
  "Trung tâm phục vụ hành khách NBA",
  "Trung tâm điều hành NBA",
  "Ban Giám đốc DAD",
  "Phòng kế hoạch hành chính DAD",
  "Phòng kế toán DAD",
  "Trung tâm phục vụ sân đỗ DAD",
  "Trung tâm phục vụ hành khách DAD",
  "Trung tâm điều hành DAD",
  "Trung tâm Phục vụ hàng hóa DAD",
  "PHÒNG CNTT",
  "Đội ĐBVH & Hạ tầng",
  "Đội Phát triển CNTT",
  "Đội Quản trị CNTT",
  "Đội Chuyển đổi số",
  "TRUNG TÂM ĐIỀU HÀNH",
  "TRUNG TÂM PHỤC VỤ HÀNH KHÁCH",
  "TRUNG TÂM PHỤC VỤ SÂN ĐỖ",
  "PHÒNG KẾ HOẠCH HÀNH CHÍNH",
  "KẾ TOÁN",
  "Bộ phận Hành chính",
  "Nhóm Kế hoạch đầu tư, mua sắm",
  "Tổ Quản trị tòa nhà",
  "Bộ phận Đảng, đoàn thể",
  "Nhóm Dữ liệu",
  "Nhóm Chất lượng",
  "Nhóm Hợp đồng và Phát triển bán",
  "Trung tâm đào tạo khu vực miền Nam",
  "Trung tâm Đào tạo",
  "Trung tâm đào tạo khu vực miền Bắc",
  "Nhóm An toàn",
  "Nhóm Đào tạo và hành chính tổng hợp",
  "Nhóm Kế toán",
  "Nhóm Tài chính",
  "Nhóm Tổ chức lao động",
  "Nhóm Tiền lương chính sách",
  "Nhóm Marketing",
  "Nhóm An ninh",
  "Đội kiểm soát tải NBA",
  "Đội điều hành và Quản trị cơ sở dữ liệu",
  "Trung tâm đào tạo khu vực miền Trung",
  "Đội dịch vụ phòng khách Bông Sen",
  "Bộ phận Y tế",
  "Khối văn phòng",
  "Bộ phận thư ký tổng hợp",
  "Bộ phận Truyền thông",
  "Xưởng SC & BD TTB NBA",
  "Xưởng SC & BD TTB DAD",
  "Xưởng SC & BD TTB TSN",
  "Đội Kiểm soát tải Đà Nẵng",
  "Đội Kiểm soát tải TSN",
  "PVTB Kíp 2",
  "Đội Cung ứng vật tư",
  "PVVT Kíp Cấp phát",
  "PVVT Kíp Đóng gói",
  "PVVT Văn phòng",
  "Văn phòng Phục vụ sân đỗ",
  "DVKT Văn phòng",
  "Đội Hướng dẫn chất xếp",
  "PVHL Kíp 1",
  "DVSĐ Kíp 16 BX",
  "PVTB Văn phòng",
  "DVSĐ Văn phòng",
  "Đội Phục vụ hành khách Quốc nội",
  "Đội Phục vụ Hành khách các Hãng",
  "PVHL Văn phòng",
  "Tổ Quản lý chất lượng",
  "Văn phòng Trung tâm Điều hành",
  "Đội Phục vụ hành khách Quốc tế",
  "Đội xe Phục vụ tổ bay",
  "HKCT LNF",
  "HKCT Kíp 2",
  "Đội Phục vụ hành khách đến và chuyển tiếp",
  "HKCT Kíp 1",
  "HKCT Văn phòng",
  "HKCT Kíp 3",
  // Add more entries as needed
];

export const eLocationOptions = ["Tân Sơn Nhất", "Nội Bài", "Đà Nẵng"];

export const eSystemTypeOptions = ["Nội bộ", "Bên ngoài"];

export const eTeamOptions = [
  "Đội Phát triển CNTT",
  "Đội ĐBVH và Hạ Tầng CNTT",
  "Nhóm Đảm Bảo Vận Hành CNTT",
  "Nhóm văn phòng công ty",
  "Ban CNTT",
  "AITS",
  "TTĐH KT",
  "Ban ATCL",
  "Ban TTBSP",
  "Ban DVHK",
];

export const eTypeClassOptions = ["J", "M-PR4", "M", "ECONOMY"];

export const eAmadeusSystemOptions = ["CM", "FM", "CM và FM"];
export const eAmadeusUserGroupOptions = ["Quản lý", "SUP", "Nhân viên", "Viewer"];
export const eAmadeusDutyCodeOptions = ["GS", "SU"];
export const eAmadeusOfficeOptions = [
  "SGNVN00CI",
  "SGNVN00SU",
  "SGNVN00VI",
  "HANVN00CI",
  "HANVN00SU",
  "HANVN00VI",
  "DADVN00SU",
  "DADVN00VI",
  "DADVN00CI",
  "SGNVN0001",
  "HANVN0001",
  "DADVN0001",
];
